import IBaseComponent from '@components/FormFlow/Interfaces/Base/IBaseComponent';
import IModelComponent from '@components/FormFlow/Interfaces/FormflowComponents/IModelComponent';
import { LocalStorageKeys } from '@containers/App';
import { ComponentType } from '@interfaces/component-type';
import { IModel3D } from '@interfaces/IModel3D';
import IPagination from '@interfaces/IPagination';
import { ITarget } from '@interfaces/ITargets';
import Switch from '@material-ui/core/Switch';
import Model3DService from '@services/qa/Model3DService';
import TargetService from '@services/TargetService';
import I18n from '@src/i18n';
import styled, { Theme } from '@src/styled-components';
import { Col, InputNumber, Radio, Row, Select } from 'antd';
import CheckboxGroup from 'antd/lib/checkbox/Group';
import React from 'react';

import ProcessContext from '../ProcessContext';


const Option = Select.Option;
const RadioGroup = Radio.Group;

interface IModelTaskComponentStateType {
  instructionTitle: string;
  description?: string;
  model3DId: string | undefined;
  animations?: string[];
  realObjects?: string[];
  url: string;
  models: IModel3D[];
  targets: ITarget[];
  offset?: string,
  toggleAR?: boolean;

  targetId: string;
  urlTarget: string;
  xPosition: number;
  yPosition: number;
  zPosition: number;
  xRotation: number;
  yRotation: number;
  zRotation: number;
  scale: number;
};

export class ModelComponent implements IModelComponent {
  id: string;
  type: ComponentType;
  title: string;
  description?: string;
  model3DId: string;
  url: string;
  constructor(id: string = '') {
    this.id = id;
    this.type = ComponentType.MODEL;
    this.title = '';
    this.model3DId = '';
    this.url = ''
    return this;
  }
}

const _mode3dService: Model3DService = new Model3DService();
const _targetService: TargetService = new TargetService();
export default class ModelComponentProcess extends React.Component<IModelComponent, IModelTaskComponentStateType> {
  private idUnit: string = '';

  constructor(props: IModelComponent) {
    super(props);
    this.idUnit = String(localStorage.getItem(LocalStorageKeys.ACTIVE_UNIT_ID))
    this.state = {
      instructionTitle: this.props.title || '',
      description: this.props.description || undefined,
      model3DId: this.props.model3DId || undefined,
      animations: this.props.animations || undefined,
      url: this.props.url,
      models: [],
      targets: [],
      toggleAR: this.props.ar ? true : false,

      targetId: this.props.ar ? this.props.ar.targetId : '',
      urlTarget: this.props.ar ? this.props.ar.url : '',
      xPosition: this.props.ar ? this.props.ar.position.x || 0 : 0,
      yPosition: this.props.ar ? this.props.ar.position.y || 0 : 0,
      zPosition: this.props.ar ? this.props.ar.position.z || 0 : 0,
      xRotation: this.props.ar ? this.props.ar.rotation.x || 0 : 0,
      yRotation: this.props.ar ? this.props.ar.rotation.y || 0 : 0,
      zRotation: this.props.ar ? this.props.ar.rotation.z || 0 : 0,
      realObjects: this.props.ar ? this.props.ar.realObjects : [],
      scale: this.props.ar ? this.props.ar.scale || 1 : 1,
    };
  }

  componentDidMount = async () => {
    this.getModels3Ds(true);
    this.getTargets(true);
    if (this.props.ar) {
      this.setState({ toggleAR: true })
    }
  }

  //#region HANDLERS
  handleIntructionTitleChange = async (evt: any) => {
    this.setState({ instructionTitle: evt.target.value });
  }

  handleDescriptionChange = async (evt: any) => {
    this.setState({ description: evt.target.value });
  }

  handleModelSelectChange = async (evt: any) => {
    this.setState({ model3DId: evt })
    const items = this.state.models.find((e: any) => e.id === this.state.model3DId)
    this.setState({ url: items ? items.url : '' })
  }

  handleTargetSelectChange = async (evt: any) => {
    this.setState({ targetId: evt })
    const items = this.state.targets.find((e: any) => e.id === this.state.targetId)
    this.setState({ urlTarget: items && items.url ? items.url : '' })
  }

  handleAnimationSelectChange = async (evt: any) => {
    let animations: string[] = []
    animations.push(evt.target.value)
    this.setState({ animations })
  }

  handleRealObjectsChange = async (checkedValues: any) => {
    // let realObjects: string[] = []
    // realObjects.push(evt.target.value)
    this.setState({ realObjects: checkedValues })
    console.log('REAL OBJECT', this.state.realObjects)
  }

  handleAR = async (evt: any) => {
    this.setState({ toggleAR: evt.target.checked })
  }
  handlePositionX = async (evt: any) => {
    this.setState({ xPosition: evt })
  }
  handlePositionY = async (evt: any) => {
    this.setState({ yPosition: evt })
  }
  handlePositionZ = async (evt: any) => {
    this.setState({ zPosition: evt })
  }
  handleRotationX = async (evt: any) => {
    this.setState({ xRotation: evt })
  }
  handleRotationY = async (evt: any) => {
    this.setState({ yRotation: evt })
  }
  handleRotationZ = async (evt: any) => {
    this.setState({ zRotation: evt })
  }

  handleScale = async (evt: any) => {
    this.setState({ scale: evt })
  }


  //#endregion

  //#region  Gets
  async getModels3Ds(reset: boolean) {
    // if (showLoading != undefined) { this.setState({ isLoading: showLoading }) };

    if (reset) {
      this.setState({
        offset: undefined
      });
    }
    try {
      const response: IPagination<IModel3D> = await _mode3dService.paging({
        unit: this.idUnit,
        to: undefined,
        from: undefined,
        limit: 100,
        offset: this.state.offset
      });
      this.setState({ models: response.items, offset: response.offset });
    } catch (e) {
      console.error(e)
    }
  }

  async getTargets(reset: boolean) {
    // if (showLoading != undefined) { this.setState({ isLoading: showLoading }) };

    if (reset) {
      this.setState({
        offset: undefined
      });
    }
    try {
      const response: IPagination<ITarget> = await _targetService.paging({
        unit: this.idUnit,
        to: undefined,
        from: undefined,
        limit: 100,
        offset: this.state.offset
      });
      this.setState({ targets: response.items, offset: response.offset });
    } catch (e) {
      console.error(e)
    }
  }


  getOptionsModel3D = () => {
    let options: JSX.Element[] = []

    for (const items of this.state.models) {
      options.push(
        <Option key={items.id} value={items.id} >{items.name}</Option>
      )
    }
    return options;
  }

  getOptionsTargets = () => {
    let options: JSX.Element[] = []

    for (const items of this.state.targets) {
      options.push(
        <Option key={items.id} value={items.id} >{items.name}</Option>
      )
    }
    return options;
  }

  getRadiosModel3D = () => {
    const radioStyle = {
      display: 'block',
      height: '30px',
      lineHeight: '30px',
    };
    let radios: JSX.Element[] = [];
    const model = this.state.models.find((e: any) => e.id === this.state.model3DId)
    if (model && model.animations && model.animations !== null) {
      for (const items of model.animations) {
        radios.push(
          <Radio key={items} style={radioStyle} value={items}>{items}</Radio>
        )
      }
    }
    return radios;
  }

  getRealObjects = () => {

    let options: any = [];
    const model = this.state.models.find((e: any) => e.id === this.state.model3DId)
    if (model && model.realObjects && model.realObjects !== null) {
      for (const items of model.realObjects) {
        options.push(
          {
            label: items,
            value: items
          }
        )
      }
    }
    return options;
  }
  //#endregion


  onSave(updateFormflowWithComponent: (component: IBaseComponent) => void) {

    const ar = {
      targetId: this.state.targetId,
      url: this.state.urlTarget,
      position: {
        x: this.state.xPosition,
        y: this.state.yPosition,
        z: this.state.zPosition,
      },
      rotation: {
        x: this.state.xRotation,
        y: this.state.yRotation,
        z: this.state.zRotation,
      },
      scale: this.state.scale,
      realObjects: this.state.realObjects
    }

    const newModelDataComponent: any = {
      model3DId: this.state.model3DId ? this.state.model3DId : '',
      animations: this.state.animations,
      url: this.props.url !== '' && this.props.url !== undefined ? this.props.url : this.state.url,
      ar: this.state.toggleAR ? ar : undefined,
    }
    updateFormflowWithComponent(newModelDataComponent);
  }

  render() {
    return (
      <div>
        <div style={{ marginBottom: '0.5rem' }}>
        </div>
        <div
          style={{ marginBottom: '0.5rem' }}
        >
          {I18n.l('formflow.components.modelComponent.uploadTitle')}
        </div>
        <Select
          style={{ width: '100%' }}
          onChange={this.handleModelSelectChange}
          defaultValue={this.state.model3DId}
        >
          {this.getOptionsModel3D()}
        </Select>

        <div>
          {(this.state.model3DId && this.state.model3DId !== '') &&
            <>
              <RadioGroup
                style={{ marginTop: '10px', marginLeft: '10px' }}
                onChange={this.handleAnimationSelectChange}
                defaultValue={this.state.animations ? this.state.animations[0] : ''}
              >
                {this.getRadiosModel3D()}
              </RadioGroup>
              <ARHidden>
                <CheckboxGroup
                  style={{ marginTop: '1rem' }}
                  defaultValue={this.state.realObjects}
                  options={this.getRealObjects()}
                  onChange={this.handleRealObjectsChange}
                />
              </ARHidden>
            </>
          }
        </div>
        <DividerBorder />
        <Row>
          <Col sm={20} md={20} xl={20} >
            {I18n.l('formflow.components.modelComponent.AR')}
          </Col>
          <Col sm={4} md={4} xl={4} >
            <Switch
              color="primary"
              onChange={this.handleAR}
              checked={this.state.toggleAR}
            />
          </Col>
        </Row>
        {this.state.toggleAR &&
        <>
          <div
            style={{ marginTop: '1rem', marginBottom: '0.5rem' }}
          >
            {I18n.l('formflow.components.modelComponent.chooseTarget')}
          </div>
          <Select
            style={{ width: '100%' }}
            onChange={this.handleTargetSelectChange}
            defaultValue={this.state.targetId}
          >
            {this.getOptionsTargets()}
          </Select>
        {/*  */}
        <Row>
          <Col sm={12} md={12} xl={12}>
            <div
              style={{ marginTop: '1rem', marginBottom: '0.5rem' }}
            >
              {I18n.l('formflow.components.modelComponent.positionX')}
            </div>
            <InputNumber onChange={this.handlePositionX} defaultValue={this.state.xPosition} style={{ width: '90%' }} />
          </Col>
          <Col sm={12} md={12} xl={12}>
            <div
              style={{ marginTop: '1rem', marginBottom: '0.5rem' }}
            >
              {I18n.l('formflow.components.modelComponent.positionY')}
            </div>
            <InputNumber onChange={this.handlePositionY} defaultValue={this.state.yPosition} style={{ width: '90%' }} />
          </Col>
          <Col sm={12} md={12} xl={12}>
            <div
              style={{ marginTop: '1rem', marginBottom: '0.5rem' }}
            >
              {I18n.l('formflow.components.modelComponent.positionZ')}
            </div>
            <InputNumber onChange={this.handlePositionZ} defaultValue={this.state.zPosition} style={{ width: '90%' }} />
          </Col>
          <Col sm={12} md={12} xl={12}>
            <div
              style={{ marginTop: '1rem', marginBottom: '0.5rem' }}
            >
              {I18n.l('formflow.components.modelComponent.rotationX')}
            </div>
            <InputNumber onChange={this.handleRotationX} defaultValue={this.state.xRotation} style={{ width: '90%' }} />
          </Col>
          <Col sm={12} md={12} xl={12}>
            <div
              style={{ marginTop: '1rem', marginBottom: '0.5rem' }}
            >
              {I18n.l('formflow.components.modelComponent.rotationY')}
            </div>
            <InputNumber onChange={this.handleRotationY} defaultValue={this.state.yRotation} style={{ width: '90%' }} />
          </Col>
          <Col sm={12} md={12} xl={12}>
            <div
              style={{ marginTop: '1rem', marginBottom: '0.5rem' }}
            >
              {I18n.l('formflow.components.modelComponent.rotationZ')}
            </div>
            <InputNumber onChange={this.handleRotationZ} defaultValue={this.state.zRotation} style={{ width: '90%' }} />
          </Col>
          <Col sm={12} md={12} xl={12}>
            <div
              style={{ marginTop: '1rem', marginBottom: '0.5rem' }}
            >
              {I18n.l('formflow.components.modelComponent.scale')}
            </div>
            <InputNumber onChange={this.handleScale} defaultValue={this.state.scale} style={{ width: '90%' }} />
          </Col>
        </Row>
        </>
        }
        <ProcessContext.Consumer>
          {({ updateProcessComponent }) => (
            <>
              {this.onSave(updateProcessComponent)}
            </>
          )}
        </ProcessContext.Consumer>
      </div>
    );
  }
}

//#region CSS
const ARHidden = styled.div`
display: none;
`;

const DividerBorder = styled.div`
    border-bottom: 1px solid  ${Theme.secondary.lightGrey};
    width: 120%;
    margin-left: -29px;
    margin-top: 2rem;
    margin-bottom: 2rem;
`;
//#endregion
